/* eslint-disable react/display-name */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, FormControl } from '@material-ui/core';
import SelectControlled from './SelectControlled';
import {
  fontColors,
  backgroundColors,
  colorDanger,
} from '../../material-ui-theme';
import { dataStylesSelectInputPaper } from './data-styles';
import FormAdvancedLabel from './FormAdvancedLabel';

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    marginTop: theme.spacing(3),
    display: 'flex',
    width: '100%',
    color: 'var(--color-fontColors-black)',
    cursor: 'pointer',
  },
  inputPaper: {
    cursor: 'pointer',
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiAutocomplete-root': {
      cursor: 'pointer',
      padding: 0,
      display: 'flex',
      width: '100%',
      '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"]': {
        cursor: 'pointer',
      },
      '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input':
        {
          cursor: 'pointer',
        },
      '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
        {
          padding: 0,
          fontSize: '0.9rem',
          fontWeight: 400,
          color: 'var(--color-fontColors-black)',
          // textTransform: 'uppercase',
        },
      '& .MuiInput-underline:before': {
        border: 'none',
      },
      '& .MuiInput-underline:after': {
        border: 'none',
      },
    },
    ...dataStylesSelectInputPaper,
  },
  inputPaperDisabled: {
    backgroundColor: backgroundColors.disabled,
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '& .MuiAutocomplete-root': {
      padding: 0,
      display: 'flex',
      width: '100%',
      '& .MuiAutocomplete-inputRoot[class*="MuiInput-root"] .MuiAutocomplete-input:first-child':
        {
          padding: 0,
          fontSize: '0.9rem',
          fontWeight: 400,
          color: fontColors.disabled,
          '-webkit-text-fill-color': fontColors.disabled,
          opacity: 1 /* required on iOS */,
          // textTransform: 'uppercase',

          '&[data-hidevalueondisabled]': {
            color: 'transparent',
          },
        },
      '& .MuiInput-underline:before': {
        border: 'none',
      },
      '& .MuiInput-underline:after': {
        border: 'none',
      },
    },
  },
  input: {
    flex: 1,
    cursor: 'pointer',
  },
  helperText: {
    margin: 0,
    fontSize: '0.9rem',
    marginTop: '3px',
    textAlign: 'left',
    fontWeight: 400,
    color: colorDanger.main,
    paddingLeft: theme.spacing(1),
  },
}));

const ElevatedSelectControlled = memo(
  ({ label, error, helperText, disabled, searchable, ...restProps }) => {
    const classes = useStyles();

    return (
      <FormControl className={classes.inputRoot} error={error}>
        {label && label !== '' ? (
          <FormAdvancedLabel>{label}</FormAdvancedLabel>
        ) : null}
        <Paper
          className={
            disabled
              ? `${classes.inputPaperDisabled} inputPaperDisabled-class`
              : classes.inputPaper
          }
          elevation={2}
          data-style-searchable={searchable ? 'true' : 'false'}
        >
          <SelectControlled
            disabled={disabled}
            searchable={searchable}
            {...restProps}
          />
        </Paper>
        {error && helperText !== '' ? (
          <p className={classes.helperText}>{helperText}</p>
        ) : null}
      </FormControl>
    );
  }
);

ElevatedSelectControlled.defaultProps = {
  label: '',
  error: false,
  helperText: '',
  disabled: false,
  hideValueOnDisabled: false,
  searchable: false,
};

ElevatedSelectControlled.propTypes = {
  label: PropTypes.string,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
  hideValueOnDisabled: PropTypes.bool,
  searchable: PropTypes.bool,
};

export default ElevatedSelectControlled;
